import {useInfiniteQuery} from 'react-query';
import {getHotPostLists} from 'services/postList';
interface GetpostListParms extends IFilters {
  product_category_guid?: string;
  app: 'farm' | 'market';
  order_by: string;
  search: string;
}

const useGetHotAuctionPostList = (params: GetpostListParms) => {
  const {
    data: postListData,
    isLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    [
      'hot-post-list',
      params.app,
      params?.order_by,
      params?.search,
      params?.product_category_guid,
      params?.type,
      params?.start_price,
      params?.end_price,
    ],
    ({pageParam = 1, queryKey}) =>
      getHotPostLists({
        page: pageParam,
        app: queryKey[1],
        order_by: queryKey[2],
        search: queryKey[3],
        product_category_guid: queryKey[4],
        type: queryKey[5],
        start_price: queryKey[6],
        end_price: queryKey[7],
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const lastRecord = allPages[allPages.length - 1]?.next || '';
        return lastRecord
          ? new URL(lastRecord).searchParams.get('page')
          : undefined;
      },
    },
  );
  return {postListData, isLoading, refetch, fetchNextPage};
};
export default useGetHotAuctionPostList;
